import React from 'react';

import Link from '@dashboard/components/mui-atoms/Link';
import Section from '@dashboard/components/sections/Section';
import { usePlatformDomainNameVerificationsQuery } from '@dashboard/generated/wp/administrator';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

type Props = {
  platformId: string;
};

export default function DomainNameVerification({ platformId }: Props) {
  const { data } = usePlatformDomainNameVerificationsQuery({ variables: { platformId } });

  const connection = data?.PlatformDomainNameVerifications;

  if (!connection) {
    return <Section title="Domain names" variant="secondary" />;
  }

  const { count, nodes } = connection;
  return (
    <Section title={<>Domain names ({count})</>} variant="secondary">
      <TableContainer>
        <Table sx={{ 'td, th': { px: 0, py: 1, border: 0 } }}>
          <TableHead>
            <TableRow>
              <TableCell variant="head">URL</TableCell>
              <TableCell variant="head">DNS verification</TableCell>
              <TableCell variant="head">Waypoint approval</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {nodes.map((n) => (
              <TableRow key={n.id}>
                <TableCell>
                  <Link href={`/admin/domains/${n.id}`}>{n.domainName}</Link>
                </TableCell>
                <TableCell>{n.status}</TableCell>
                <TableCell>{n.approvalStatus}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Section>
  );
}
